/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Architect_Output9Inputs */

const en_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline blueprint`)
};

const ar_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المخطط التفصيلي لخط الأنابيب`)
};

const bn_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাইপলাইন ব্লুপ্রিন্ট`)
};

const de_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline-Entwurf`)
};

const es_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de tubería`)
};

const fr_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan du pipeline`)
};

const pt_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano de pipeline`)
};

const zh_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管道蓝图`)
};

const tr_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boru hattı planı`)
};

const ru_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Схема трубопровода`)
};

const pl_svc_automation_architect_output9 = /** @type {(inputs: Svc_Automation_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan rurociągu`)
};

/**
* | output |
* | --- |
* | "Pipeline blueprint" |
*
* @param {Svc_Automation_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_architect_output9 = /** @type {((inputs?: Svc_Automation_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_architect_output9(inputs)
	if (locale === "bn") return bn_svc_automation_architect_output9(inputs)
	if (locale === "de") return de_svc_automation_architect_output9(inputs)
	if (locale === "es") return es_svc_automation_architect_output9(inputs)
	if (locale === "fr") return fr_svc_automation_architect_output9(inputs)
	if (locale === "pt") return pt_svc_automation_architect_output9(inputs)
	if (locale === "zh") return zh_svc_automation_architect_output9(inputs)
	if (locale === "tr") return tr_svc_automation_architect_output9(inputs)
	if (locale === "ru") return ru_svc_automation_architect_output9(inputs)
	if (locale === "pl") return pl_svc_automation_architect_output9(inputs)
	return en_svc_automation_architect_output9(inputs)
});
export { svc_automation_architect_output9 as "svc_automation_ARCHITECT_output" }